import React from 'react'
import TimelineSidebarLayout from '../../../../Shared/TimelineSidebar'
import TimelineSidebarDurationToggle from './TimelineSidebarParts/TimelineSidebarDurationToggle'
import ProjectAssets from './TimelineSidebarParts/ProjectAssets'
import ScenarioAssets from './TimelineSidebarParts/ScenarioAssets'
import TimelineNotesSection from '../../../../Shared/TimelineNotesSection'

export default function TimelineSidebar({
  activeTab = 'timeline',
}) {
  return (
    <TimelineSidebarLayout>
      {activeTab === 'notes' ? (
        <TimelineNotesSection />
      ) : (
        <>
          <TimelineSidebarDurationToggle />
          <ProjectAssets />
          <ScenarioAssets />
        </>
      )}
    </TimelineSidebarLayout>
  )
}
